import React from 'react';
import { Link } from 'react-router-dom';
import ImageWebp from 'react-image-webp';
import Constant from "../../utils/Constant";
import axios from 'axios';
import LocalStorageService from "../../utils/LocalStorageService";
import $ from "jquery";
import Header from "../common/Header";
class MovieProgram extends React.Component {
  constructor() {
    super();
    //banner
    this.state = {
      fbUrl : "",
      whatsappUrl : "",
      twitterUrl : "",
      googleUrl : "",
      linkedinUrl : ""
    }
  }
  componentDidMount() {
    let classRef = this;
    setTimeout(function () {
      classRef.renderHover();
    }, 2000)
  }

  renderHover = () => {

    let classRef = this;
    $.each(classRef.props.data, function (i) { //Loop the array
      // setTimeout(function() {
      //   $('.HoverNModelImgVid').on('click', '#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i,
      //     function (e) {
      //       if ($('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).hasClass('vidVolumemute')) {
      //         $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).removeClass('vidVolumemute');
      //         $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].muted = true;
      //       } else {
      //         $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).addClass('vidVolumemute');
      //         $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].muted = false;
      //       }
      //     }
      //   );
      // },1000)
      var timer;
      $("#glider_slider_pro" + classRef.props.sliderKey + '_' + i).mouseenter(
        function () {
          var that = this;
          timer = setTimeout(function(){          
          $("#glider_slider_pro" + classRef.props.sliderKey + '_' + i).addClass('HoverClass');
          $('#glider_slider_pro' + classRef.props.sliderKey).css("overflow", "inherit");
          if (classRef.props.data[i].episode_video_url != "") {
            // {"video_url_"+ classRef.props.sliderKey + '_' + index}
            // $("#video_url_" + classRef.props.sliderKey + '_' + i + " source").attr('src', classRef.props.data[i].episode_video_url);
            // $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].load();
            // $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].play();
            // $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].muted = true;
            if(!$('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).hasClass('addvolume')){
              $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).addClass('addvolume');  
              $('.HoverNModelImgVid').on('click', '#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i,
              function (e) {
                if ($('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).hasClass('vidVolumemute')) {
                  $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).removeClass('vidVolumemute');
                  // $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].muted = true;
                } else {
                  $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).addClass('vidVolumemute');
                  // $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].muted = false;
                }
              }
            );
            }            
            // $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].onloadeddata = function () {
            //   $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).show()
            //   $('#img_op_' + classRef.props.sliderKey + '_' + i).css('opacity', 0);

            // };
          }
          // $("#video_url_"+ classRef.props.sliderKey + '_' + i)[0].onended = function() { 
          // $('#img_op_' + i).css('opacity', 0);                               
          // };       
        }, 300);        
        }).mouseleave(function () {
          clearTimeout(timer);
          
          // $("#video_url_"+ classRef.props.sliderKey + '_' + i)[0].pause();
          if ($(".HoverClass").length > 0) {
            $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).hide()
            $("#glider_slider_pro" + classRef.props.sliderKey + '_' + i).removeClass('HoverClass');
            $('#glider_slider_pro' + classRef.props.sliderKey).css("overflow", "");
            $('#img_op_' + classRef.props.sliderKey + '_' + i).css('opacity', 1);
            // if (classRef.props.data[i].episode_video_url != "") {
            //   $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].pause();
            //   $("#video_url_" + classRef.props.sliderKey + '_' + i)[0].muted = true;
            // }
            $('#HoverNModel_vidVolume' + classRef.props.sliderKey + '_' + i).removeClass('vidVolumemute');
          }
        }
      )
    })
  }  

  addToFavourite = (heart_id, programId) => {
    
    if (!localStorage.getItem('user_id')) {
      new Header().openLoginModal();
      return;
    }
    if ($("#" + heart_id).hasClass('active')) {

      $("#heart_" + programId).removeClass('active')
      $("#" + heart_id).removeClass('active');
      let classRef = this;
      axios({
        method: 'POST',
        url: Constant.url + "remove-favourite",
        headers: { 'Authorization': "bearer " + localStorage.getItem("access_token") },
        data: { program_id: programId, user_id: localStorage.getItem('user_id') },
      }).then(function (result) {
        let response = {};
        response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
        
        if (response.data.code === 200 && response.data.status === true) {


        }
      })
    } else {
      $("#" + heart_id).addClass('active');
      $("#heart_" + programId).addClass('active')
      let classRef = this;
      axios({
        method: 'POST',
        url: Constant.url + "add-user-favourite-programs",
        headers: { 'Authorization': "bearer " + localStorage.getItem("access_token") },
        data: { program_id: programId, user_id: localStorage.getItem('user_id') },
      }).then(function (result) {
        let response = {};
        response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
        
        if (response.data.code === 200 && response.data.status === true) {

        }
      })
    }
  }

  handleProgramList = () => {
    let programs = "";
    let classRef = this;
    // console.log("movies data: ", this.props.data);
    programs = this.props.data.map((program, index) => (
      <div key={index} className='ProgramsCard' id={"glider_slider_pro" + classRef.props.sliderKey + '_' + index}>
        <Link className="newProgBox" to={"/movies/" + program.episode_slug}>
          <div className="shows_slider_img">
                <img src={"https://www.mjunoon.tv/" + program.episode_poster} alt={program.episode_name} onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = "data:image/png;base64,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";
                    }}
 />
              <div className="chnl_hvr_box"><span uk-icon="play"></span></div>
            </div>
        </Link>        
      </div>
    ));
    return programs;
  };



  
  render() {
    return (
      <div>
        <section className="pad_left pad_t shows_slider_sec moviesSectionHome ProgramSectionHome">
          <div className="headng_box">
            <h2 className="h2forhome"><strong>{(this.props.type) ? this.props.name + ' ' + this.props.type : this.props.name}</strong></h2>
           {(this.props.name !== "") ? <Link className="view_all" to={"/movies"}>{(window.location.pathname === '/') ? 'View All' : ''}</Link> : '' } </div>
          <div className="slider_new_container drama_sldr_container">
            <div className="drama_sldr_new" uk-slider='finite: true; sets: true;draggable: true;'>
              <div className="uk-slider-items">
                {this.handleProgramList()}
              </div>
              <a class="CarouselPrevBtn" href="#" uk-slider-item="previous"><img src="/images/left_arrow.png" alt="right arrow" /></a>
              <a class="CarouselNextBtn" href="#" uk-slider-item="next"><img src="/images/right_arrow.png" alt="right arrow" /></a>
            </div>
          </div>
        </section>
        <hr />
      </div>
    );
  }
}

export default MovieProgram;